var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachFile = function SvgAttachFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "attach_file_svg__a",
    width: 24,
    height: 24,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0h24v24H-1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#attach_file_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 15.75q0 2.6-1.825 4.425Q13.349 22 10.75 22q-2.6 0-4.425-1.825T4.5 15.75V6.5q0-1.875 1.313-3.187Q7.125 2 9 2t3.188 1.313T13.5 6.5v8.75q0 1.15-.8 1.95t-1.95.8a2.65 2.65 0 0 1-1.95-.8 2.65 2.65 0 0 1-.8-1.95V7q0-.424.287-.713A.97.97 0 0 1 9 6q.424 0 .713.287Q10 6.576 10 7v8.25a.73.73 0 0 0 .75.75.73.73 0 0 0 .75-.75V6.5q-.025-1.05-.738-1.775Q10.05 4 9 4t-1.775.725T6.5 6.5v9.25q-.025 1.775 1.225 3.012T10.75 20q1.75 0 2.975-1.238T15 15.75V7q0-.424.287-.713A.97.97 0 0 1 16 6q.424 0 .712.287Q17 6.576 17 7z"
  }))));
};
export default SvgAttachFile;